(function () {
  function initTrustpilotWidgets() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== "function") {
      return;
    }

    var widgets = document.querySelectorAll(".trustpilot-widget");
    widgets.forEach(function (el) {
      // Avoid double initialization
      if (el.dataset.tpInitialized === "true") {
        return;
      }
      try {
        window.Trustpilot.loadFromElement(el);
        el.dataset.tpInitialized = "true";
      } catch (e) {
        // Fail silently in case Trustpilot is not ready yet
        console && console.debug && console.debug("Trustpilot init error", e);
      }
    });
  }

  // Run once on initial load
  document.addEventListener("DOMContentLoaded", initTrustpilotWidgets);

  // Watch for new widgets added by Algolia (sorting, filtering, pagination)
  var observer = new MutationObserver(function (mutations) {
    var found = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (
          node.matches(".trustpilot-widget") ||
          node.querySelector(".trustpilot-widget")
        ) {
          found = true;
        }
      });
    });

    if (found) {
      initTrustpilotWidgets();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
